import { Axios } from "../../Services/Axios";

export const login = async (payload) => {
  return await Axios.post("/store/login", payload, { responseType: "json" });
};
